import { measurementMethodOf, registrationTypeOf } from '../dataHelpers/measurementMethods'

// AI-CONTEXT: See docs/features/output-registratie-per-keer-of-totaal.md (ADR-070)
// One registration has one date for every output in it (buildRegistrationDocs),
// so the convention for period totals is a single line under the form's date
// field. Shared by AddEvent (logged in) and EventOpen (public) so both forms
// show exactly the same line.

const CONVENTION = 'Kies als datum de laatste dag van die periode.'

/** @param {string[]} names @returns {string} */
const joinNames = (names) => {
  const quoted = names.map((name) => `'${name}'`)
  if (quoted.length === 1) return quoted[0]
  return `${quoted.slice(0, -1).join(', ')} en ${quoted[quoted.length - 1]}`
}

/**
 * The line to show under the date field, or null when no output in the form is
 * a period total. When every output typed in on the form is a total the line is
 * generic; in a mixed form it names the totals.
 *
 * @param {Array<{ Title?: string, MeasurementMethod?: string, RegistrationType?: string }> | undefined} outputs
 * @returns {string | null}
 */
const registrationDateHint = (outputs) => {
  const formOutputs = (outputs || []).filter((output) => measurementMethodOf(output) === 'event_form')
  const totals = formOutputs.filter((output) => registrationTypeOf(output) === 'period_total')
  if (totals.length === 0) return null
  if (totals.length === formOutputs.length) return `Vul je een totaal over een periode in? ${CONVENTION}`
  const names = joinNames(totals.map((output) => output.Title))
  return `${names} ${totals.length === 1 ? 'is een totaal' : 'zijn totalen'} over een periode. ${CONVENTION}`
}

export default registrationDateHint
